<form class="popupForm" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <ng-container *ngIf="mode == 'show_purchases'">{{'pick_service_title'|GetLabelPipe}}</ng-container>
      <ng-container *ngIf="mode == 'show_proposals'">{{'pick_proposal_title'|GetLabelPipe}}</ng-container>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke flex-justify-start" style="display: flex !important; height: 500px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        >.< error. <br>{{errMsg}}
      </div>
      <ng-container *ngIf="state==='default'">
        <div  *ngIf="!packages || !packages.length"
              style="margin: 20px 0px; font-size: 0.8em;">
          no services.
        </div>

        <div *ngIf="packages && packages.length" class="events-listing-container listing-full-size" style="margin-top: 20px !important;">

          <ng-container *ngFor="let groupItem of packageGroups; let gdx = index">

          <br *ngIf="gdx>0" />
          <div class="group-label">{{(gdx+1)}}. {{groupItem}}</div>
          <mat-accordion class="services-accordion" multi>
            <mat-expansion-panel *ngFor="let package of packagesGrouped[gdx]; let idx = index">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div style="margin-bottom: 12px;">{{(idx+1)}}. {{package['package_name']}}</div>
                </mat-panel-title>
                <mat-panel-description>
                  <div style="margin-bottom: 12px;">
                    <ng-container *ngIf="package['price'] != package['guest_price'] && package['price'] != package['discount_price']">
                      Price/Guest/Discount: <b>{{package['price']}}/{{package['guest_price']}}/{{package['discount_price']}} {{package['currency']}}</b>
                    </ng-container>
                    <ng-container *ngIf="package['price'] != package['guest_price'] && package['price'] == package['discount_price']">
                      Price/Guest: <b>{{package['price']}}/{{package['guest_price']}} {{package['currency']}}</b>
                    </ng-container>
                    <ng-container *ngIf="package['price'] == package['guest_price'] && package['price'] != package['discount_price']">
                      Price/Discount: <b>{{package['price']}}/{{package['discount_price']}} {{package['currency']}}</b>
                    </ng-container>
                    <ng-container *ngIf="package['price'] == package['guest_price'] && package['price'] == package['discount_price']">
                      Price: <b>{{package['price']}} {{package['currency']}}</b>
                    </ng-container>
                  </div>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <br/>
              <div>
                Duration: <b>{{package['params']['days_limit']}} days</b>.
              </div>
              <br/>

              <ng-container *ngFor="let serviceItem of package['services']; let jdx = index">
                <br/>
                <div *ngIf="serviceItem['status'] == 'general'">
                  {{(jdx+1)}}. <b>{{serviceItem['name']}}</b><ng-container *ngIf="serviceItem['qty']>1"> (x{{serviceItem['qty']}})</ng-container>.
                </div>
                <ng-container *ngIf="serviceItem['params']['unit'] == 'training'">
                  <mat-error class="form-error"
                             *ngIf="packagesGrouped[gdx][idx]['__validated'] && !packagesGrouped[gdx][idx]['__valid']">
                    Please pick a trainer
                  </mat-error>
                  <mat-form-field appearance="outline" color="accent" style="width: 220px;">
                    <select matNativeControl formControlName="trainerPickControl_{{gdx}}_{{idx}}_{{jdx}}">
                      <option value="0">--- Pick a trainer---</option>
                      <option *ngFor="let trainer of trainers" value="{{trainer['ID']}}">{{trainer['SHIPPING_NAME']}}</option>
                    </select>
                  </mat-form-field>
                  <br>
                </ng-container>
                <div *ngIf="serviceItem['status'] == 'BUNDLED'">
                  <mat-checkbox [value]="serviceItem['service_id']" formControlName="checkBundledControl_{{gdx}}_{{idx}}_{{jdx}}"
                                (click)="uncheckBundled(serviceItem['bundle_picker'],gdx,idx,jdx)"
                                class="radio-button">
                    <div class="textCut">
                      {{(jdx+1)}}. <b>{{serviceItem['name']}}</b>
                      <ng-container *ngIf="serviceItem['qty']>1"> (x{{serviceItem['qty']}}) </ng-container> <span class="subrow" style="display: inline">(additional service)</span>.
                    </div>
                  </mat-checkbox>
                </div>
              </ng-container>

              <mat-action-row class="flex-justify-start">
                <button mat-raised-button color="accent" [disabled]="pickItemsLoading"
                        (click)="saveService(gdx,idx)">
                  <ng-container *ngIf="mode == 'show_purchases'">{{'save_picked_service'|GetLabelPipe}}</ng-container>
                  <ng-container *ngIf="mode == 'show_proposals'">{{'save_picked_proposal'|GetLabelPipe}}</ng-container>
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
          </ng-container>

        </div>
        <br>
      </ng-container>

    </mat-dialog-content>
  </div>
</form>
